import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formBody.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d6ob88blgirdouph2ol0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          company: '',
          email: '',
          phone: '',
          service: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-0">
      <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen">
        <div className="relative bg-amber-50 flex items-center justify-center p-12">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/f80a015f1e4ec2ea50f094565fcdc7b2.jpg"
              alt="Professional Cleaning"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        <div className="bg-white flex items-center justify-center p-12">
          <div className="w-full max-w-lg">
            <h3 className="text-5xl font-bold text-gray-900 mb-2 text-center leading-tight">
              Schedule Your
            </h3>
            <h3 className="text-5xl font-bold text-gray-900 mb-8 text-center leading-tight">
              Service Now
            </h3>
            <p className="text-gray-600 text-base text-center mb-12 leading-relaxed max-w-md mx-auto">
              Get a free consultation and quote within 24 hours. Our team is ready to discuss your cleaning needs and create a customized solution for your facility.
            </p>

            <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="space-y-5">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-teal-600 transition-colors"
              />
              <input
                type="text"
                name="company"
                placeholder="Company Name"
                value={formData.company}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-teal-600 transition-colors"
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-teal-600 transition-colors"
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-teal-600 transition-colors"
              />
              <select
                name="service"
                value={formData.service}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-teal-600 transition-colors cursor-pointer"
              >
                <option value="">Select Service Type</option>
                <option value="office-cleaning">Office Cleaning</option>
                <option value="floor-care">Floor Care</option>
                <option value="sanitization">Sanitization</option>
                <option value="window-washing">Window Washing</option>
                <option value="carpet-cleaning">Carpet Cleaning</option>
                <option value="post-construction">Post-Construction</option>
              </select>
              <textarea
                name="message"
                placeholder="Tell us about your cleaning needs..."
                value={formData.message}
                onChange={handleChange}
                maxLength={500}
                rows={4}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-teal-600 transition-colors resize-none"
              ></textarea>

              {submitStatus === 'success' && (
                <div className="bg-green-50 text-green-800 px-4 py-3 rounded-lg text-sm text-center">
                  Thank you! We'll contact you within 24 hours.
                </div>
              )}
              {submitStatus === 'error' && (
                <div className="bg-red-50 text-red-800 px-4 py-3 rounded-lg text-sm text-center">
                  Something went wrong. Please try again.
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full md:w-72 mx-auto block bg-gray-900 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {isSubmitting ? 'Sending...' : 'Contact for Quote'}
                {!isSubmitting && <i className="ri-arrow-right-line text-xl"></i>}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}